import React from 'react';
import {Typography, useMediaQuery, useTheme} from '@mui/material';

const AlignedText = props=>{
    let {italic, bold, ...rest} = props;
    let theme = useTheme();
    let sm = useMediaQuery(theme.breakpoints.down('sm'));

    return <Typography
      textAlign={sm ? 'center' : null}
      fontStyle={italic ? 'italic' : null}
      fontWeight={bold ? 'bold' : null}
      {...rest}/>;
};

export default AlignedText;
